import { createContext, useState, ReactNode } from "react";
import { jwtDecode } from "jwt-decode";
import { AuthContextType, AuthProviderProps, AuthState, JwtPayload } from "../types/auth";

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: AuthProviderProps) => {
    const hs = '$2a$12$vf5J1rN32sCdfVDEZw2xlu';
    const [auth, setAuth] = useState<AuthState>({});
    const [persist, setPersist] = useState<boolean>(JSON.parse(localStorage.getItem("persist") || "false"));
    const [session, setSession] = useState<string>(localStorage.getItem("session_id") || "");

    const habRoles = (role: string[]): boolean => {
        const decoded = auth?.access_token !== undefined && auth?.access_token !== ""
            ? jwtDecode<JwtPayload>(auth.access_token)
            : undefined;

        let user_roles: string[] = [];
        let jsonInfo: string | string[] = decoded?.roles || "[]";
        if (typeof jsonInfo === "string") {
            jsonInfo = JSON.parse(jsonInfo) as string[];
        }

        if (jsonInfo.length > 0) {
            user_roles = jsonInfo as string[];
        }

        let hab = false;
        user_roles.map((ro: any) => {
            for (let i = 0; i < role.length; i++) {
                if (ro === role[i]) {
                    hab = true;
                }
            }
        });

        return hab;
    };

    const setSessionId = (session_id: string) => {
        if (session_id === "") {
            localStorage.removeItem("session_id");
            setSession("");
        } else {
            localStorage.setItem("session_id", session_id);
            setSession(session_id);
        }
    };

    const getSessionId = (): string => {
        return session;
    };

    return (
        <AuthContext.Provider value={{ auth, setAuth, persist, setPersist, habRoles, getSessionId, setSessionId, hs }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
